
import {Component, Vue, Watch, Ref} from "vue-property-decorator";
import { Socket } from "vue-socket.io-extended";
import app from "@/main";
import { ProgramPaths } from "@/enum/ProgramPaths";
import MenuBar from "@/components/page-components/MenuBar.vue";
import BildirimInfo from "@/components/infos/BildirimInfo.vue";
import SorguOneriInfo from "@/components/infos/SorguOneriInfo.vue";
import UrunlerInfo from "@/components/infos/UrunlerInfo.vue";
import ImzaUyapConnectionInfo from "@/components/infos/ImzaUyapConnectionInfo.vue";
import UserInfoCard from "@/components/UserInfoCard.vue";
import AppFooter from "@/layout/AppFooter.vue";
import GuncellemelerInfo from "@/components/infos/GuncellemelerInfo.vue";
import KaynaklarInfo from "@/components/infos/KaynaklarInfo.vue";
import AnketInfo from "@/components/infos/AnketInfo.vue";
import SpinnerToast from "@/components/SpinnerToast.vue";
import LisansKisitBar from "@/components/LisansKisitBar.vue";
import RatingDialog from "@/components/dialogs/RatingDialog.vue";
import KatkiPaneliTanitimDialog from "@/components/dialogs/KatkiPaneliTanitimDialog.vue";
import RenewalButton from "@/components/renewal/RenewalButton.vue";
import RenewalModal from "@/components/renewal/RenewalModal.vue";
import RenewalCountdownBar from "@/components/renewal/RenewalCountdownBar.vue";
import DemoCountdownBar from "@/components/demo/DemoCountdownBar.vue";
import _swal from "sweetalert2";
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {
  kotaUyarisiKancasiniAyarla,
  devreKesiciKancasiniAyarla,
  durumMesajiKancasiniAyarla,
  DurumMesajiTipi
} from "@/plugins/uyap-plugin/BaglantiKurtarma";
import {PlayerDurum} from "@/plugins/uyap-plugin/store/modules/GorevYoneticisiTypes";
import {isletimSistemiBildirimi, uyariSesi} from "@/plugins/kritikUyari";
import {senkronZamanlayicilariniBagla} from "@/plugins/senkronZamanlayicilar";
import {senkronEkranindanCikar} from "@/utils/senkronKapisi";
import OturumLimitiDialog from "@/components/dialogs/OturumLimitiDialog.vue";
import DevreKesiciDialog from "@/components/dialogs/DevreKesiciDialog.vue";
import ImzaKimlikSeridi from "@/components/imza/ImzaKimlikSeridi.vue";
import {kimlikUyusmazligiKancasiniAyarla} from "@/plugins/uyap-plugin/OturumKimligi";
import {kimlikUyusmazligiUyarisiOlustur} from "@/utils/kimlikUyusmazligiUyarisi";
import {guvenliImzaMesaji} from "@/utils/imzaMesaji";
import UyapEngelSeridi from "@/components/imza/UyapEngelSeridi.vue";
import UyapEngeliDialog from "@/components/dialogs/UyapEngeliDialog.vue";
import {uyapEngelKancasiniAyarla, uyapEngelDisKaynaginiAyarla} from "@/plugins/uyap-plugin/UyapEngeli";
import {uyapEngelKancasiOlustur, kapiReddiToastiOlustur} from "@/utils/uyapEngelKancasi";
import {imzaciEngelBildirimi} from "@/utils/uyapEngel";

declare global {
  interface Window {
    pekiSettings: any;
  }
}

// "Daha Sonra Hatırlat" / kapatma sonrasi anketin tekrar gosterilmeyecegi sure (1 gun).
const RATING_SNOOZE_MS = 24 * 60 * 60 * 1000;

// Katki Paneli tanitimi kullanici basina YALNIZ BIR KEZ gosterilir; kapatildiginda
// (X / "Daha sonra" / ESC / dis tiklama / panele gitme) kalici olarak isaretlenir.
// Ileride yeni bir tanitim gerekirse surum artirilir: "...:v2".
const KATKI_PANELI_TANITIM_KEY = "katkiPaneliTanitim:v1";

@Component({
  computed: {
    ProgramPaths() {
      return ProgramPaths;
    },
  },
  components: {
    LisansKisitBar,
    AppFooter,
    UserInfoCard,
    ImzaUyapConnectionInfo,
    ImzaKimlikSeridi,
    UrunlerInfo,
    BildirimInfo,
    SorguOneriInfo,
    MenuBar,
    GuncellemelerInfo,
    KaynaklarInfo,
    AnketInfo,

    SpinnerToast,
    RatingDialog,
    KatkiPaneliTanitimDialog,
    RenewalButton,
    RenewalModal,
    RenewalCountdownBar,
    DemoCountdownBar,
    OturumLimitiDialog,
    DevreKesiciDialog,
    UyapEngelSeridi,
    UyapEngeliDialog,
  }
})
export default class App extends Vue {
  drawer = null as boolean | null; // null olarak başlat
  isAnaMenu = false;
  ProgramPaths = ProgramPaths;
  showRatingDialog: boolean = false;
  showKatkiPaneliTanitim: boolean = false;
  oturumLimitiAcik: boolean = false;
  devreKesiciAcik: boolean = false;
  uyapEngeliAcik: boolean = false;
  private kapiReddiDinleyicisi: ((olay: any) => void) | null = null;

  @Ref("spinnerToast") readonly spinnerToast!: SpinnerToast;

  created() {
    this.drawer = true;
    this.$store.commit('initAutoPlay');
    // Socket önceden bağlandıysa watcher tetiklenmez; imzacı bağlantı durumu buradan başlar.
    this.$store.dispatch('imzaSocketDurumu', !!(this.$socket && this.$socket.connected));
    this.baglantiKurtarmaKancalariniBagla();
    this.senkronZamanlayicilariniKur();
    // UYAP engeli (DEV-3572): açılışta sunucudan "Bot" aynası KURULMAZ (arayuz-1, uyum-1). Sunucudaki 24 saatlik
    // olay botun gerçek durumunun kanıtı değildir; ayna yalnız imzacının canlı `notification.uyapEngeli` duyurusundan
    // kurulur. Sunucu kaydı yalnız Başlat'ta (`playerBaslatOnayli`) onay sorulsun mu kararı için okunur.
  }

  beforeDestroy() {
    if (this.kapiReddiDinleyicisi) {
      window.removeEventListener("unhandledrejection", this.kapiReddiDinleyicisi);
      this.kapiReddiDinleyicisi = null;
    }
  }

  /**
   * uyap-plugin, kota dolu ve devre kesici uyarılarını kanca üzerinden bildiriyor;
   * kancayı kaydetmek uygulamanın işi (plugin store/DOM'a bağlanmasın diye).
   * kotaUyarisiKancasiniAyarla bugüne dek HİÇ çağrılmamıştı: DEV-2447'nin
   * anlattığı kota dialogu bu yüzden kullanıcıya hiç görünmedi.
   *
   * Bot gece de çalışıyor; kullanıcı ekrana bakmıyorken dialog tek başına yetmez,
   * bu yüzden işletim sistemi bildirimi ve ses de veriliyor (vue-imza-app ile aynı
   * davranış). Ses yalnızca uyarı ilk açıldığında çalar; her turda çalarsa
   * kanıksanır ve sinyal değerini yitirir.
   */
  private baglantiKurtarmaKancalariniBagla() {
    // Bu uygulamada durum mesajı toast olarak gösteriliyor; vue-imza-app aynı
    // kancayı UyapStatusCard'daki satır içi mesaja bağlıyor.
    durumMesajiKancasiniAyarla((tip: DurumMesajiTipi, metin: string) => {
      if (tip === "error") this.$toast.error(metin);
      else if (tip === "success") this.$toast.success(metin);
      else this.$toast.info(metin);
    });

    kotaUyarisiKancasiniAyarla(() => {
      if (this.oturumLimitiAcik) {
        return;
      }
      this.oturumLimitiAcik = true;
      isletimSistemiBildirimi(
          "UYAP oturum sınırına ulaşıldı",
          "Açık UYAP oturumlarınızı kapatıp yeniden bağlanın."
      );
      uyariSesi();
    });

    // Kimlik kapısı (UyapRequest) hesap/oturum TCKN uyuşmazlığında bu kancayı çağırır;
    // kaydedilmemişti, uyarı yalnız eski oturum yoklamasında satır içi vardı.
    kimlikUyusmazligiKancasiniAyarla(kimlikUyusmazligiUyarisiOlustur());

    devreKesiciKancasiniAyarla(() => {
      if (this.devreKesiciAcik) {
        return;
      }
      // Botu durdur: kesici açıldıysa görev kuyruğunun devam etmesi ban riskini büyütür.
      this.$store.commit("setPlayerDurum", PlayerDurum.dur);
      this.devreKesiciAcik = true;
      isletimSistemiBildirimi(
          "İşlemler durduruldu",
          "UYAP bağlantısında tekrarlayan hata; ban riskine karşı işlemler durduruldu."
      );
      uyariSesi();
    });

    // UYAP insan doğrulaması (DEV-3572): kilit kurulunca plugin kancayı BİR kez çağırır. Plugin kilidi YALNIZ kanca
    // kayıtlıysa kurar (kimsenin kaldıramayacağı kilit olmasın): bu yüzden created()'ta, ilk UYAP isteğinden ÖNCE.
    // Kanca botu durdurmaz: durdurmayı plugin `uyapEngeliBotuDurdur` yapar (tek sahip; panelde yalnız bağlıysa yayın).
    uyapEngelKancasiniAyarla(uyapEngelKancasiOlustur({
      store: this.$store,
      pencereAc: () => {
        this.uyapEngeliAcik = true;
      },
      bildir: (baslik: string, metin: string) => {
        isletimSistemiBildirimi(baslik, metin);
        uyariSesi();
      }
    }));
    // Plugin `autoPlayer` ("İşlem oluştuktan sonra başlat") botun engelini panel biliyorsa 'oto' yaymasın.
    // Yalnız 'oto' yayınını etkiler; panelin kapısını kapatmaz (SOZLESME §5.2, C16).
    uyapEngelDisKaynaginiAyarla(() => this.$store.getters.uyapEngeliImzaciAktif === true);
    // Kayıttan ÖNCE kurulmuş bir kilit varsa aynaya al (olağan dışı; maliyeti yok).
    this.$store.dispatch("uyapEngeliSenkronla");
    // Yakalanmamış engel/kapı reddi için kısa toast (pencere açmaz; yalnız `uyapEngelHatasiMi`, 10 sn'de en çok bir).
    this.kapiReddiDinleyicisi = kapiReddiToastiOlustur({toast: this.$toast});
    window.addEventListener("unhandledrejection", this.kapiReddiDinleyicisi);
  }

  /**
   * Faz 3 zamanlayıcıları: gece öncesi kontrol (DEV-2967) ve sabah raporu
   * (DEV-2968). Zamanlama uyap-plugin'de AYRI modüllerde duruyor; Görev
   * Yöneticisi'ne dokunulmadı. Kancalar burada kaydediliyor çünkü işletim
   * sistemi bildirimi uygulamanın işidir (kritikUyari plugin'de değil).
   *
   * `$nextTick` ZORUNLUDUR, kozmetik değil. `created()` Vue 2'de `new Vue(...)`
   * çağrısının İÇİNDE senkron olarak ateşleniyor; `main.ts` ise app'i ancak
   * `.$mount('#app')` döndükten SONRA dışa veriyor (`export default app`).
   * Zamanlayıcının "saat geçmişse hemen ateşle" yakalaması senkron çalıştığı
   * için, doğrudan çağrıldığında `@/main`den `app` okuyan her modül (servis
   * katmanı `app.$http`) DAİRESEL import yüzünden `undefined` görüyordu:
   * sabah raporu bildirimi sessizce hiç çıkmıyor, ön-kontrol ise "planlar
   * okunamadı" diye YANLIŞ alarm veriyordu. Mikro göreve ertelemek `main.ts`in
   * modül gövdesinin bitmesini garanti eder.
   */
  private senkronZamanlayicilariniKur() {
    this.$nextTick(() => senkronZamanlayicilariniBagla(this.$store));
  }

  mounted() {
    // Spinner service'e component referansını ver
    this.$nextTick(() => {
      if (this.$spinner && this.spinnerToast) {
        (this.$spinner as any).setComponent(this.spinnerToast);
      }
      // Sira onemli: tanitim bekliyorsa checkAndShowRating erken doner,
      // iki modal ust uste acilmaz.
      this.checkAndShowKatkiPaneliTanitim();
      this.checkAndShowRating();
    });
  }

  // Yenileme teklifi ve demo geri sayimi icin burada ISTEK ATILMAZ: ikisinin de
  // ham verisi /api/v1/ben yanitindaki `lisans_durum` alaniyla geliyor ve
  // sessionStorage'daki user ile birlikte duruyor. Bu yuzden sayfa yenilemesi
  // sifir istek eder; hesap renewalOfferFor / demoStatusFor getter'larinda yapilir.
  @Watch("userId")
  onUserIdChangeForRenewal(id: number | undefined) {
    if (id) {
      // mounted sirasinda henuz login olunmamis olabilir; tanitim burada yakalanir.
      this.checkAndShowKatkiPaneliTanitim();
    }
  }

  // Kimlik (token + büro + TCKN) imzacıya devri: giriş, büro değişimi, socket (yeniden)
  // bağlanması, imzacının açılması ve kullanıcı düğmesi tetikler. Aynı kimlikli yakın
  // tetikleyiciler birleşir (bkz. utils/kimlikDevri.ts).
  @Watch("userId")
  onUserIdChangeForKimlik(id: number | undefined) {
    if (id) {
      this.$store.dispatch("kimlikDevret", {neden: "giris"});
    }
  }

  @Watch("$store.state.tenant_id")
  onTenantIdChangeForKimlik() {
    this.$store.dispatch("kimlikDevret", {neden: "buro"});
  }

  // Eski oturum yoklaması görev listesini de yüklüyordu; devir artık yalnız kimlik taşıdığı
  // için liste imza bağlantısı kurulunca burada tazelenir.
  @Watch("$store.getters.isImzaConnected")
  onImzaBaglantisiChange(bagli: boolean) {
    if (bagli && this.userId) {
      this.$store.dispatch("updateTasks").catch(() => undefined);
    }
  }

  // Otomatik sorgu kapısı (DEV-2603, karar 20.10.2026): kapı kapanırsa (sunucu 409
  // `senkron_kapali` döndü ya da `/ben` yenilendi) plan ekranında duran kullanıcı
  // ekrandan çıkarılır. Menü ve zamanlayıcılar kapıyı kendileri izler.
  @Watch("$store.getters.senkronAktif")
  onSenkronAktifChange(aktif: boolean) {
    senkronEkranindanCikar(aktif === true, this.$route.path, this.$router);
  }

  get isEicrapro() {
    return this.$route.path.includes(ProgramPaths.eicrapro);
  }

  get ratingMode() {
    return this.isEicrapro ? 'beta-screen' : 'general';
  }

  get pendingTakipHazirlaRatingDialog(): boolean {
    return this.$store.getters['takipHazirla/pendingTakipHazirlaRatingDialog'];
  }

  checkAndShowRating() {
    if (this.isEicrapro) {
      return;
    }
    // Katki Paneli tanitimi acik ya da hala sirada ise anketi bekletiriz;
    // ilk giriste kullaniciyi ust uste iki modalle karsilamayalim.
    if (this.showKatkiPaneliTanitim || !this.isKatkiPaneliTanitimSeen()) {
      return;
    }
    // Kullanici "Daha Sonra Hatirlat" / X dediyse, sure dolana dek tekrar acma.
    if (this.isRatingSnoozed('general')) {
      return;
    }
    if (this.userId) {
      this.showRatingDialog = true;
    }
  }

  /** Tanitim kaydi kullanici bazli tutulur; ayni bilgisayardaki her hesap bir kez gorur. */
  get katkiPaneliTanitimKey(): string {
    const userId = this.$store.state.user.id;
    return `${KATKI_PANELI_TANITIM_KEY}:${userId || 'anonim'}`;
  }

  isKatkiPaneliTanitimSeen(): boolean {
    try {
      return localStorage.getItem(this.katkiPaneliTanitimKey) === '1';
    } catch (e) {
      // localStorage kapaliysa "gorulmus" say: her acilista tekrar gostermekten iyidir.
      return true;
    }
  }

  checkAndShowKatkiPaneliTanitim() {
    if (!this.userId || this.isKatkiPaneliTanitimSeen()) {
      return;
    }
    this.showKatkiPaneliTanitim = true;
  }

  /**
   * Tanitim hangi yolla kapanirsa kapansin (X / "Daha sonra" / ESC / dis tiklama /
   * panele gitme) bir kez gorulmus sayilir ve sirada bekleyen anket serbest kalir.
   */
  @Watch("showKatkiPaneliTanitim")
  onKatkiPaneliTanitimChange(val: boolean) {
    if (val) {
      return;
    }
    try {
      localStorage.setItem(this.katkiPaneliTanitimKey, '1');
    } catch (e) {
      console.error('Katkı Paneli tanıtımı kaydedilemedi:', e);
    }
    this.$nextTick(() => this.checkAndShowRating());
  }

  // Toggle metodu ekle
  toggleDrawer() {
    this.drawer = !this.drawer;
  }

  // MenuBar'dan gelen close-drawer event'ini handle et
  closeDrawer() {
    if (this.$vuetify.breakpoint.smAndDown) {
      this.drawer = false;
    }
  }

  // Route'a göre drawer durumunu ayarlayan method
  setDrawerStateByRoute() {
    const isMainRoute =
        this.$route.path === ProgramPaths.ofispro ||
        this.$route.path === ProgramPaths.icrapro ||
        this.$route.path === ProgramPaths.eicrapro;

    if (isMainRoute) {
      this.drawer = true;
    }
  }

  get userId() {
    let id = this.$store.state.user.id;
    return id;
  }

  get showDevWarn() {
    let isEicrapro = this.$route.path.includes(ProgramPaths.eicrapro);
    let isTestSite =
        location.hostname.split(".")[0] == "cloudtest" ||
        location.hostname.split(".")[0] == "cloudbeta" ||
        location.hostname.split(".")[0] == "localhost";
    return isEicrapro && isTestSite && this.$store.getters.isEicraproDevMode;
  }

  toggleDevMode(): void {
    const nextState = !this.$store.state.eicraproDevMode;
    this.$store.commit("setEicraproDevMode", nextState);
    this.$store.dispatch("kimlikDevret", {neden: "kullanici"});
  }

  @Socket("player")
  onPlayer(player: any) {
    this.$store.commit("setPlayerDurum", Number(player));
    // Kullanıcı eylemi (çıplak SAYI 0: onaylı Başlat) imzacıdaki kilidi imzacıda kaldırır; panelin bot bilgisi de
    // silinir. Metin "0" (otomatik / kabuğun yeniden oynatması) kilidi KALDIRMAZ (SOZLESME §4.5 tür kuralı): bu
    // yüzden `Number(player)` ile DEĞİL, sıkı karşılaştırma.
    if (player === PlayerDurum.oto) this.$store.commit("uyapEngeliImzaciTemizle");
    this.$store.dispatch("uyapEngeliSenkronla");
  }

  @Socket("updateTasks")
  onUpdateTask() {
    this.$store.dispatch("updateTasks");
  }

  @Socket("imzaMessage")
  async onImzaMessage(message: any) {
    console.log("imzaMessage Fired", message);
    // Kabuk olayı tüm istemcilere yayınlıyor: yalnız kanonik alanlar gösterilir (html vb. atılır).
    const guvenli = guvenliImzaMesaji(message);
    if (guvenli) {
      await _swal.fire(guvenli);
    }
  }

  // İmzacının şu an adına çalıştığı büro/avukat (kabuk 2.0.5+; eski kabukta olay hiç gelmez).
  @Socket("botKimligi")
  onBotKimligi(data: any) {
    this.$store.commit("setBotKimligi", data);
  }

  @Socket("uyapAvukatBilgileri")
  onAvukatBilgileriChange(data: {uyapAvukatBilgileri: KullaniciBilgileriCevap, uyapAvukatBakiye: string, uyapSorguBakiye: string}) {
    this.$store.commit("setUyapAvukatBilgileri", data.uyapAvukatBilgileri);
    this.$store.commit("setUyapAvukatBakiye", data.uyapAvukatBakiye);
    this.$store.commit("setUyapSorguBakiye", data.uyapSorguBakiye);
  }

  @Socket("refreshConnection")
  onRefreshConnection() {
    console.log("Socket refreshConnection triggered");
    // İmzacı yeni açıldı ve updateToken'ı kaçırmış olabilir: birleşme/uçuş kuyruğuna takılmadan yeniden devredilir.
    this.$store.dispatch("kimlikDevret", {neden: "imzaci-acildi"});
  }

  @Socket("notification")
  onNotification(notification: { message: string, seconds: number, uyapEngeli?: any }) {
    // İmzacının engel duyurusu (DEV-3572, SOZLESME §6): {message: 'Bot: UYAP engeli nedeniyle durdu · HH:MM',
    // seconds: 8, uyapEngeli: {zaman}}. Çarklı "Cevap bekleniyor" toast'ı YERİNE şeridin Bot satırı kurulur
    // (kabuk olayı ham aktarır). İşaretsiz bildirimler (evrak/fren `Waiting`) bugünkü gibi spinner'a gider.
    const engel = imzaciEngelBildirimi(notification);
    if (engel) {
      this.$store.commit("setUyapEngeliImzaci", engel);
      return;
    }
    this.$spinner.message(notification.message,notification.seconds);
  }

  @Socket("uyapconnection")
  async onUyapConnection(data: { connected: boolean; JSESSIONID: string }) {
    console.log("soket cevap uyap bağlı", data.connected ? "EVET" : "HAYIR");
    if (data) {
      this.$store.commit("setUyapConnection", data.connected);
      if (
          !(
              window.localStorage.hasOwnProperty("JSESSIONID") &&
              window.localStorage.getItem("JSESSIONID") == data.JSESSIONID
          )
      ) {
        localStorage.setItem("JSESSIONID", data.JSESSIONID);
        // TODO: port değişken yapılacak
        const cookieSetUrl =
            "https://imza.eicrapro.com:6099" +
            "/cookie?" +
            data.JSESSIONID +
            ";SameSite=None;Secure";
        try {
          await app.$uyap.SetCookie().run({ url: cookieSetUrl });
        } catch (e) {
          // Muaf uç (kapıya takılmaz) ama async olay işleyicisi try/catch'siz kalmasın (DEV-3572 savunma).
          console.warn("UYAP çerezi yazılamadı:", e);
        }
      }
    }
  }

  @Watch("$route")
  onPathnameChange() {
    if (
        this.$route.path == ProgramPaths.ofispro ||
        this.$route.path == ProgramPaths.icrapro ||
        this.$route.path == ProgramPaths.eicrapro
    ) {
      this.isAnaMenu = true;
      this.drawer = true; // Ana menüde drawer'ı aç
    } else {
      this.isAnaMenu = false;
      // Mobilde route değiştiğinde drawer'ı kapat
      if (this.$vuetify.breakpoint.smAndDown) {
        this.drawer = false;
      }
    }

    // Anket kontrolü (Route değiştiğinde de kontrol et)
    this.checkAndShowRating();
  }

  @Watch("$socket.connected")
  onSocketConnectionChange() {
    console.log("Socket connected WATCH");
    const bagli = !!(this.$socket && this.$socket.connected);
    this.$store.dispatch("imzaSocketDurumu", bagli);
    // Kopuşta devir denenmez; imzacıdan gelen durum (UYAP bayrağı, bot kimliği, avukat bilgisi)
    // imzaSocketDurumu(false) ile sıfırlanır. (Yeniden) bağlanınca kabuk kimliği yitirmiş olabilir
    // ve durumu kendisi yeniden yayınlar.
    if (bagli) {
      this.$nextTick(() => {
        this.$store.dispatch("kimlikDevret", {neden: "socket"});
      });
    }
  }

  @Watch("pendingTakipHazirlaRatingDialog")
  onPendingTakipHazirlaRatingChange(pending: boolean) {
    if (this.showKatkiPaneliTanitim) {
      return;
    }
    if (pending && this.isEicrapro && this.userId && !this.isRatingSnoozed('beta-screen')) {
      this.showRatingDialog = true;
    }
  }

  @Watch("showRatingDialog")
  onShowRatingDialogChange(val: boolean) {
    if (!val) {
      this.$store.commit('takipHazirla/CLEAR_PENDING_TAKIP_HAZIRLA_RATING');
    }
  }

  onRatingSave(data: { rating: number, comment: string }) {
    console.log('User Rating:', data);
    this.$toast.success('Görüşleriniz için teşekkür ederiz!');
  }

  /**
   * Anket "Daha Sonra Hatirlat" veya capraz (X) ile kapatildiginda tetiklenir.
   * Ilgili modu 1 gun boyunca "ertelendi" olarak isaretler; bu sure dolana kadar
   * ekran degisimlerinde anket tekrar acilmaz.
   */
  onRatingRemindLater(mode: string) {
    this.snoozeRating(mode || this.ratingMode);
  }

  ratingSnoozeKey(mode: string): string {
    return `ratingDialogSnoozeUntil:${mode}`;
  }

  isRatingSnoozed(mode: string): boolean {
    try {
      const raw = localStorage.getItem(this.ratingSnoozeKey(mode));
      if (!raw) {
        return false;
      }
      const until = Number(raw);
      return Number.isFinite(until) && Date.now() < until;
    } catch (e) {
      return false;
    }
  }

  snoozeRating(mode: string): void {
    try {
      const until = Date.now() + RATING_SNOOZE_MS;
      localStorage.setItem(this.ratingSnoozeKey(mode), String(until));
    } catch (e) {
      console.error('Anket hatirlatma suresi kaydedilemedi:', e);
    }
  }
}
